import { NotificationService } from '../../_services/notification.service';
import { DomSanitizer} from '@angular/platform-browser'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from 'ng2-translate';
import { PostService } from '../../model/post.service';
import { FirebaseListObservable, AngularFireDatabase } from 'angularfire2/database-deprecated';
import {
  Component, OnInit, Input, ChangeDetectionStrategy, SimpleChanges, OnChanges, ViewChild,
  Output,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Lightbox } from 'angular2-lightbox';
import { StoragePathPipe } from '../../_pipe/storage-path.pipe';
import { AlertService } from '../../_services/alert.service';
import { UserService } from '../../_services/user.service';
import { DatabaseSnapshot } from 'angularfire2/database-deprecated/interfaces';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { CommentLoaderComponent } from '../../directive/comment-loader/comment-loader.component';

@Component({
  selector: 'app-native-add',
  templateUrl: './post-native-add.component.html',
  styleUrls: ['./post-native-add.component.css'],
  providers: [PostService],
  changeDetection:ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
            style({ transform: 'translateX(-100%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateX(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }))
          ]
        )])
  ]
})
export class PostNativeAddComponent implements OnInit {
  message;
  testReply;
  show = false;
  friends: FirebaseListObservable<any[]>;
  comments: {};
  user: any;
  files: any[] = [];
  model: any[] = [];
  isSeen = true;
  isSilencedForMe = false;
  isSeenText = true;
  postFiles: any[] = [];
  censorPhoto=false;
  userId = this.userService.getUid();
  private subscription: Subscription = new Subscription();
  isMouseOver: boolean;
  _isLiked: boolean;
  _isComment: boolean;
  _isInMyFollowingPosts: boolean;
  _isRepost: boolean;
  maxLength = 200;
  textExposedHide = '...';
  isCollapsable = false;
  html: string;
  text:string;
  firstPost = [];
  @Input() post: any;
  // @Input() firstPost: any;
  
  @Output() reload = new EventEmitter();
  @ViewChild(CommentLoaderComponent) commentLoader: CommentLoaderComponent;
  constructor(
    private afm: AngularFireDatabase,
    private userService: UserService,
    public translate: TranslateService,
    private _lightbox: Lightbox,
    public modalService: NgbModal,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public router: Router, private alertService: AlertService,private sanitizer:DomSanitizer,private cd:ChangeDetectorRef) {
    translate.setDefaultLang("tr");
    
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user
    }));
    

    
    
  }

  scroll() {
    try {
      this.commentLoader.commentText.nativeElement.scrollIntoView({ behavior: "smooth", block: "center" });
      this.commentLoader.focus();
    } catch (e) {
      // if (!this.userId)
        // this.router.navigate(['auth'], { queryParams: { returnUrl: this.router.url } });
    }
  }

  

  ngOnDestroy() {
  this.subscription.unsubscribe();
  }


  ngOnInit(): void {
  
  }


}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/post-native-add/post-native-add.component.ts